import React, {useState} from 'react';
import axios from 'axios';
import classes from './Guard.module.css';
const { NODE_ENV, REACT_APP_BASE_URL } = process.env;

const Guard = () => {
    const [elemConfig, setConfig] = useState({
        readOnly: true
    })

    const removeElem = ()=>{
        console.log('remove')
        document.getElementById('Password').removeAttribute('readonly');
    }
    const addElem = ()=>{
        console.log('add')
        document.getElementById('Password').setAttribute('readonly', 'readonly');
    }
    const submitForm = (event) =>{
        event.preventDefault();
        let pass = event.target.children[0].value;
        let body = {password: pass};
        const url = NODE_ENV === 'development' ? "http://localhost:60702/api/testlogin" : `${REACT_APP_BASE_URL}/api/testlogin`;

        fetch(url, {
            method: 'POST',
            headers: {
               'Content-Type': 'application/json'
            },
            mode: 'cors',
            credentials: 'include',
            redirect: 'follow',
            body: JSON.stringify(body)
         }).then(response =>{
            const redirectPath = sessionStorage.getItem("redirectAfterLogin") || "/";
            console.log('redirect path is:' + redirectPath);
            sessionStorage.removeItem("redirectAfterLogin");
            window.location.href = redirectPath;

            // window.location.pathname = '/adventures'
         }).catch(e => {
            console.trace(e);
         });
    }
    return (
        <div className={classes.Guard}>
            <h3>Password required</h3>
            <form onSubmit={submitForm} >
              <input type="password" id="Password" name="Password" autoComplete="new-password" readOnly onBlur={addElem} onFocus={removeElem} />

            <button type="submit">Sign In</button>
            </form>
        </div>
    )
}

export default Guard
